import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { equal, copy } from 'helpers/deep';
import { urlSearchToObject, cleanSearchParams } from 'helpers/urlSearchParams';
import i18n from 'i18next';
import InvoicesList from './InvoicesList/InvoicesList';
import './Invoices.css';

class Invoices extends Component {
  constructor(props) {
    super(props);
    this.handleCheckBoxClick = this.handleCheckBoxClick.bind(this);
  }

  componentDidMount() {
    this.handleSearch();
    this.props.setAppState((prevState) => ({
      isNavCollapsed: true,
      invoices: {
        ...prevState.invoices,
        shouldLoad: true,
        paySingleInvoice: false,
        singlePayInvoiceNumber: undefined,
        OrderId: undefined,
        selectedInvoices: [],
        hasPaidInvoice: false,
      },
      invoiceJobs: {
        ...prevState.invoiceJobs,
        shouldLoad: true,
      },
    }));

    this.props.setHeadTitle(i18n.t('head:Invoices'));
  }

  shouldComponentUpdate(nextProps, nextState) {
    return !equal(this.props, nextProps) || !equal(this.state, nextState);
  }

  componentDidUpdate(prevProps) {
    this.handleSearch();

    if (this.props.location !== prevProps.location || prevProps.filterItemValue !== this.props.filterItemValue) {
      this.props.setHeadTitle(i18n.t('Invoices'));
    }
  }

  componentWillUnmount() {
    this.props.data.abortController.abort();

    this.props.setAppState((prevState) => ({
      isNavCollapsed: false,
      invoices: {
        ...prevState.invoices,
        abortController: new AbortController(),
      },
    }));
  }

  handleSearch() {
    const { searchType, ...globalSearchParams } = cleanSearchParams(urlSearchToObject(this.props.location.search));

    if (!equal(this.props.data.globalSearchParams, globalSearchParams)) {
      this.props.setAppState((prevState) => ({
        invoices: {
          ...prevState.invoices,
          globalSearchParams,
          pageNumber: 1,
          shouldLoad: true,
        },
      }));
    }
  }

  handleCheckBoxClick(invoice) {
    const selectedInvoices = copy(this.props.data.selectedInvoices);

    const invoiceNumber = invoice.InvoiceNumber;
    const selectedInvoicesNumbers = selectedInvoices.map((item) => item.InvoiceNumber);

    if (selectedInvoicesNumbers.includes(invoiceNumber)) {
      const indexOfInvoiceNumber = selectedInvoicesNumbers.indexOf(invoiceNumber);
      if (indexOfInvoiceNumber > -1) {
        selectedInvoices.splice(indexOfInvoiceNumber, 1);
      }
    } else {
      selectedInvoices.push(invoice);
    }

    this.props.setAppState((prevState) => ({
      invoices: {
        ...prevState.invoices,
        selectedInvoices,
      },
    }));
  }

  render() {
    const isGlobalSearch = this.props.location.search.includes('searchType');

    return (
      <div className="invoices">
        <InvoicesList {...this.props} isGlobalSearch={isGlobalSearch} saveInvoiceNumbers={this.handleCheckBoxClick} />
      </div>
    );
  }
}

Invoices.propTypes = {
  location: PropTypes.shape({
    search: PropTypes.string,
  }),
  setAppState: PropTypes.func,
  setHeadTitle: PropTypes.func,
  data: PropTypes.shape({
    abortController: PropTypes.shape({
      abort: PropTypes.func,
    }),
    selectedInvoices: PropTypes.arrayOf(PropTypes.shape({})),
    globalSearchParams: PropTypes.shape({}),
  }),
  filterFieldValue: PropTypes.string,
  filterItemValue: PropTypes.string,
};

export default Invoices;



// WEBPACK FOOTER //
// ./src/containers/Invoices/Invoices.jsx